module.exports = __webpack_public_path__ + "img/taobao.9b12b3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/buy_img/taobao.jpg
// module id = erLD
// module chunks = 0